const industries = [
    { text: 'Business, Promotion', id: 1 },
    { text: 'Creative Arts, Fashion, Media', id: 2 },
    { text: 'Science, Engineering, Construction', id: 3 },
    { text: 'Medical, Wellbeing, Sport', id: 4 },
    { text: 'Agriculture, Animals, Food', id: 5 },
    { text: 'Government, Law, Education', id: 6 },
    { text: 'Accountancy, Finance, Insurance', id: 7 },
    { text: 'Tourism, Hospitality', id: 8 },
    { text: 'Transport, Logistics', id: 9 },
    { text: 'Something not on the list', id: 10 },
];

export default industries;
